import { Link } from "react-router-dom";
import { Star, Calendar } from "lucide-react";

export const MovieCard = ({ movie, onClick }) => {
  const posterUrl = movie.poster_path || "https://via.placeholder.com/300x450/171717/7c3aed?text=No+Poster";
  const year = movie.release_date?.split("-")[0];

  const CardContent = () => (
    <div
      className="movie-card relative group rounded-xl overflow-hidden bg-[#171717] border border-white/5 cursor-pointer"
      data-testid={`movie-card-${movie.movie_id}`}
    >
      {/* Poster */}
      <div className="aspect-[2/3] relative overflow-hidden">
        <img
          src={posterUrl}
          alt={movie.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
          loading="lazy"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        
        {/* Rating Badge */}
        {movie.vote_average > 0 && (
          <div className="absolute top-2 right-2 flex items-center gap-1 px-2 py-1 rounded-full bg-black/70 backdrop-blur-sm text-xs font-medium">
            <Star className="w-3 h-3 text-yellow-400 fill-yellow-400" />
            <span className="text-white">{movie.vote_average.toFixed(1)}</span>
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-3">
        <h3 className="font-semibold text-sm text-white truncate group-hover:text-violet-400 transition-colors">
          {movie.title}
        </h3>
        {year && (
          <div className="flex items-center gap-1 mt-1 text-xs text-gray-400">
            <Calendar className="w-3 h-3" />
            <span>{year}</span>
          </div>
        )}
        {movie.genres?.length > 0 && (
          <div className="flex flex-wrap gap-1 mt-2">
            {movie.genres.slice(0, 2).map((genre, idx) => (
              <span
                key={idx}
                className="px-2 py-0.5 text-xs rounded-full bg-violet-500/10 text-violet-300 border border-violet-500/20"
              >
                {genre}
              </span>
            ))}
          </div>
        )}
      </div>
    </div>
  );

  if (onClick) {
    return (
      <div onClick={() => onClick(movie)}>
        <CardContent />
      </div>
    );
  }

  return (
    <Link to={`/movie/${movie.movie_id}`}>
      <CardContent />
    </Link>
  );
};

// Skeleton for loading state
export const MovieCardSkeleton = () => (
  <div className="rounded-xl overflow-hidden bg-[#171717] border border-white/5 animate-pulse">
    <div className="aspect-[2/3] bg-white/5" />
    <div className="p-3 space-y-2">
      <div className="h-4 bg-white/5 rounded w-3/4" />
      <div className="h-3 bg-white/5 rounded w-1/2" />
    </div>
  </div>
);
